module.exports = __webpack_public_path__ + "img/twitter.2c6290da.svg";